import { useEffect, useRef } from "react";
import PropTypes from "prop-types";

const ShadowScroll = ({ children, className }) => {
  const contentRef = useRef(null);
  useEffect(() => {
    const onScroll = () => {
      const contentDiv = contentRef.current;
      const wrapperDiv = contentDiv.parentElement;
      const shadowTopDiv = wrapperDiv.querySelector(".tw-top-0");
      const shadowBottomDiv = wrapperDiv.querySelector(".tw-bottom-0");
      const contentScrollHeight = contentDiv.scrollHeight - wrapperDiv.offsetHeight;
      const currentScroll = contentDiv.scrollTop / contentScrollHeight;
      shadowTopDiv.style.opacity = currentScroll;
      shadowBottomDiv.style.opacity = 1 - currentScroll;
    };
    contentRef.current?.addEventListener("scroll", onScroll);
    return () => contentRef.current?.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <div className="tw-relative">
      <div
        className={`tw-content-[''] tw-absolute tw-left-0 tw-w-full tw-h-[8px] tw-top-0 tw-bg-[linear-gradient(180deg,rgba(128,128,128,.25),transparent)] tw-opacity-0`}
      />
      <div
        className={`tw-content-[''] tw-absolute tw-left-0 tw-w-full tw-h-[8px] tw-bottom-0 tw-bg-[linear-gradient(0deg,rgba(128,128,128,.25),transparent)]`}
      />
      <div ref={contentRef} className={`tw-overflow-auto ${className}`}>
        {children}
      </div>
    </div>
  );
};

ShadowScroll.propTypes = {
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
};

ShadowScroll.defaultProps = { className: "" };

export default ShadowScroll;
